import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

function DownloadIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <svg
      {...svgProps}
      viewBox="0 -50 560 560"
    >
      <g>

        <path d="M373.333,234.667c-76.48,0-138.667,62.187-138.667,138.667S296.853,512,373.333,512S512,449.813,512,373.333     S449.813,234.667,373.333,234.667z M373.333,490.667C308.48,490.667,256,438.187,256,373.333S308.48,256,373.333,256     s117.333,52.48,117.333,117.333C490.56,438.08,438.08,490.56,373.333,490.667z" fill={color}/>
        <path d="M412.8,377.173l-28.8,28.8v-90.56c0-5.333-3.84-10.133-9.067-10.88c-6.613-0.96-12.267,4.16-12.267,10.56v90.667     l-28.587-28.587c-4.267-4.16-11.093-4.16-15.253,0c-4.16,4.267-4.16,11.093,0,15.253l46.933,47.04     c4.16,4.16,10.987,4.267,15.253,0l46.933-47.04c4.16-4.267,4.053-11.093-0.213-15.253     C423.573,373.12,416.96,373.12,412.8,377.173z" fill={color}/>
        <path d="M181.333,384H97.067c4.373-5.653,7.573-12.16,9.28-19.093c0.213-0.853,0.32-1.707,0.32-2.56V128h320v63.68     c0,5.333,3.84,10.133,9.067,10.88C442.347,203.52,448,198.4,448,192v-74.667c0-5.867-4.8-10.667-10.667-10.667h-32V64     c0-5.867-4.8-10.667-10.667-10.667H168.533l-30.72-48.427C135.893,1.813,132.48,0,128.853,0H10.667C4.8,0,0,4.8,0,10.667v351.68     c0,0.853,0.107,1.707,0.32,2.56c5.76,23.147,25.92,38.827,50.453,39.893c0.853,0.32,1.707,0.427,2.56,0.533h127.68     c5.333,0,10.133-3.84,10.88-9.067C192.853,389.653,187.733,384,181.333,384z M85.333,117.333V360.96     c-4.8,16.747-20.16,22.72-32,22.72c-11.84,0-27.2-5.973-32-22.72V21.333H122.88L153.6,69.76c1.92,3.093,5.333,4.907,9.067,4.907     H384v32H96C90.133,106.667,85.333,111.467,85.333,117.333z" fill={color}/>

      </g>
    </svg>
  );
}

DownloadIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

DownloadIcon.defaultProps = {
  height: 21,
  width: 21,
};

export default pure(DownloadIcon);
